const DesignLibraryHelpers = {
    urls: {
        search: () => '/designs',
        overview: () => '/designs',
    },
} as const;

export { DesignLibraryHelpers };
